import { Component, OnInit, Renderer2 } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ReceivementConferenceRequestModel } from 'src/app/wings-mobile/models/conference/receivement-conference-request.model';
import { ReceivementFollowUpRequestModel } from 'src/app/wings-mobile/models/conference/receivement-follow-up-request.model';
import { ReceivementFollowUpResponseModel } from 'src/app/wings-mobile/models/conference/receivement-follow-up-response.model';
import { ReceivementConferenceService } from 'src/app/wings-mobile/services/conference/receivement-conference.service';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { InputGenericComponent } from '../../../../shared/input-generic/input-generic.component';
import { AlertCustomComponent } from '../../../../shared/alert-custom/alert-custom.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'conference',
    templateUrl: './conference.component.html',
    styleUrls: ['./conference.component.scss'],
    imports: [FormsModule, InputTextModule, NgClass, NgIf, ButtonDirective, InputGenericComponent, AlertCustomComponent, ConfirmDialogModule, DialogModule, TranslatePipe]
})
export class ConferenceComponent implements OnInit {

	inputQuantityDisable: boolean;
	showPartAndDescription: boolean;

	receivementFollowUpRequest: ReceivementFollowUpRequestModel;
	receivementFollowUpResponse: ReceivementFollowUpResponseModel[];

	invalidAmount: boolean = false;

	inputFields = [];


	errorMessage: string;
	errorFocus: string;
	errorTitle: string;
	showAlert: boolean = false;
	fieldFocus: boolean = false;
	displayModal: boolean = false;
	partError: string;

	constructor(
		public globals: Globals,
		private beep: MessageBeep,
		private receivementConferenceService: ReceivementConferenceService,
		private translate: TranslateService,
		private renderer: Renderer2,
		private confirmationService: ConfirmationService) {
		this.beep = beep;
		this.receivementConferenceService = receivementConferenceService;
		this.translate = translate;
		this.renderer = renderer;
		this.confirmationService = confirmationService;
		this.showPartAndDescription = false;
		this.inputQuantityDisable = true;

		this.resetInputFields();
	}

	ngOnInit(): void { }

	ngAfterViewInit() {
		this.inputFields[0].value = null;
		this.inputFields[1].value = null;
		this.focusInputFields("label_conference", true);
	}

	focusInputFields(elId: string = "remove", focusZebra: boolean = false) {
		switch (elId) {
			case "label_conference":
				this.inputFields[0].focus = true;
				this.inputFields[1].focus = false;
				break;
			case "input_quantity":
				this.inputFields[0].focus = false;
				this.inputFields[1].focus = true;
				break;
			default:
				this.inputFields[0].focus = false;
		}
		if (focusZebra) {
			this.renderer.selectRootElement('#scanner_id').focus();
		}
	}

	checkLabelConference() {
		this.inputFields[1].value = null;

		this.receivementFollowUpRequest = {
			bkSubDivsionUidK: this.globals.user.warehouse.bkSubDivisionUidD,
			bkwarehouseUidK: this.globals.user.warehouse.warehouseUidK,
			bkLanguageC: this.globals.user.language,
			receivingLabel: this.inputFields[0].value,
			dockLabel: null,
			partType: "POPIMS",
			part: null,
			gspnPreffix: null,
			gspnBase: null,
			gspnSuffix: null,
			serial: null,
			type: null,
			document: null,
			dateStart: null,
			dateEnd: null
		}

		if (this.inputFields[0].value === null || this.inputFields[0].value.length === 0) {
			this.resetOnErrorLabelConference(this.translate.instant('label.labelRequired'));
			return;
		}

		this.receivementFollowUpRequest.receivingLabel = this.inputFields[0].value;
		this.receivementConferenceService.postFind(this.receivementFollowUpRequest).subscribe({
			next: res => {
				this.receivementFollowUpResponse = res;
				if (!this.receivementFollowUpResponse || this.receivementFollowUpResponse.length === 0) {
					this.inputFields[0].value = null;
					this.showPartAndDescription = false;
					this.resetOnErrorLabelConference(this.translate.instant('label.labelNotFound'));
				} else {
					if (this.receivementFollowUpResponse[0].status === true) {
						this.resetOnErrorLabelConference(this.translate.instant('label.labelVerified'));
						return;
					}
					this.inputQuantityDisable = false;
					this.showPartAndDescription = true;
					this.inputFields[0].valid = true;
					setTimeout(() => this.renderer.selectRootElement('#input_quantity').focus(), 100);
				}
			},
			error: () => {
				this.resetOnErrorLabelConference(this.translate.instant('label.labelNotFound'));
			}
		})
	}

	checkInputValid(elId: string) {
		switch (elId) {
			case "label_conference":
				this.inputFields[0].valid = false;
				break;
			case "input_quantity":
				this.inputFields[1].valid = false;
				this.invalidAmount = false;
				break;
			default:
				this.resetOnErrorLabelConference("Dev Error: Verify parameter in checkInputValid()");
		}
		this.focusInputFields(elId);
	}

	executeAction(item) {
		eval(item.action);
	}

	resetOnErrorLabelConference(errorMsg: string = "Error Ocurred") {
		this.showPartAndDescription = false;
		this.inputFields[0].valid = false;
		this.inputQuantityDisable = true;
		this.showErrorModal("modal.error", errorMsg, "label_conference");
	}

	checkQuantity() {
		if (this.inputFields[1].value <= 0 ||
			// TODO se debe verificar en backend o frontend?¿
			//this.inputFields[1].value > this.receivementFollowUpResponse[0].receivingQty ||
			this.inputFields[1].value === null ||
			this.inputFields[1].value === undefined) {
			// this.beep.showAlertCustom('modal.error', 'modal.invalidAmount');
			this.invalidAmount = true;
		} else {
			this.qtyOk();
		}
	}

	operationConfirm() {
		if (this.inputFields[1].value < this.receivementFollowUpResponse[0].receivingQty) {
			this.confirm();
		} else {
			this.confirmConference();
		}
	}

	confirmConference() {
		let receivementConferenceRequestModel: ReceivementConferenceRequestModel = new ReceivementConferenceRequestModel();
		receivementConferenceRequestModel.receivingCounted = this.inputFields[1].value;
		receivementConferenceRequestModel.bkSubDivsionUidK = this.globals.user.warehouse.bkSubDivisionUidD;
		receivementConferenceRequestModel.userC = this.globals.user.userName;
		receivementConferenceRequestModel.language = this.globals.user.language;
		receivementConferenceRequestModel.siteCode = this.globals.tokenData.fordSiteCode;
		receivementConferenceRequestModel.bkwarehouseUidK = this.globals.user.warehouse.warehouseUidK;
		receivementConferenceRequestModel.groupNum = this.receivementFollowUpResponse[0].groupNum;
		receivementConferenceRequestModel.docCode = this.receivementFollowUpResponse[0].docCode;
		receivementConferenceRequestModel.partCode = this.receivementFollowUpResponse[0].partCode;
		receivementConferenceRequestModel.gspnCode = this.receivementFollowUpResponse[0].gspnCode;
		receivementConferenceRequestModel.boxCode = this.receivementFollowUpResponse[0].boxCode;
		receivementConferenceRequestModel.groupId = this.receivementFollowUpResponse[0].groupId;
		receivementConferenceRequestModel.receivingLabelNum = this.receivementFollowUpResponse[0].receivingLabelNum;
		receivementConferenceRequestModel.receivingQty = this.receivementFollowUpResponse[0].receivingQty;
		receivementConferenceRequestModel.receivingDate = new Date();
		receivementConferenceRequestModel.updateS = this.receivementFollowUpResponse[0].updateS;
		receivementConferenceRequestModel.status = true; //conferido

		this.receivementConferenceService.putConference(receivementConferenceRequestModel).subscribe({
			next: res => {
				this.resetInputFields();
				this.resetModels();
				this.renderer.selectRootElement("#scanner_id").focus();
				this.beep.successBeep();
				this.inputQuantityDisable = true;
			},
			error: err => {
				if (typeof err.error !== 'string') {
					this.beep.showAlertCustom("ERROR!", this.translate.instant('modal.connectionFailed'), "#scanner_id");
				} else if (err.error && "#" == err.error.substr(0, 1)) {
					this.partError = err.error.replace("#", "");
					this.showModalDialog();
				}
				else {
					this.showErrorModal("modal.error", err.error, "input_quantity", true);
					this.qtyError();
				}
			}
		});
	}

	resetInputFields() {
		this.inputFields = [
			{
				name: "label_conference",
				id: "label_conference",
				focus: true,
				value: null,
				action: "this.checkLabelConference()",
				valid: false
			},
			{
				name: "input_quantity",
				id: "input_quantity",
				focus: false,
				value: null,
				action: "this.checkQuantity()",
				valid: false
			}
		];
	}

	resetModels() {
		this.receivementFollowUpRequest = null;
		this.receivementFollowUpResponse = null;
	}

	checkInputs() {
		let disable = false;
		this.inputFields.forEach(item => {
			if (!item.valid) {
				disable = true;
			}
		});
		return disable;
	}

	confirm() {
		setTimeout(() => this.confirmationService.confirm({
			message: this.translate.instant('modal.smalleQty'),
			header: this.translate.instant('modal.confirmation'),
			acceptLabel: this.translate.instant('modal.yes'),
			rejectLabel: this.translate.instant('modal.no'),
			accept: () => {
				this.confirmConference();
			},
			reject: () => {
				this.qtyError();
			}
		}), 10);
	}

	qtyError() {
		this.renderer.selectRootElement("#input_quantity").focus();
		this.inputFields[1].value = null;
	}

	qtyOk() {
		this.inputFields[0].focus = false;
		this.inputFields[1].focus = false;
		this.inputFields[1].valid = true;
		this.renderer.selectRootElement("#input_quantity").blur();
	}

	showErrorModal(title: string, msg: string, focus?: string, fieldFocus?: boolean) {
		this.errorTitle = this.translate.instant(title);
		this.errorMessage = this.translate.instant(msg);
		this.errorFocus = focus;
		this.showAlert = true;
		this.fieldFocus = fieldFocus;
		this.beep.errorBeep();
	}

	hideErrorModal(elId) {
		this.inputFields.forEach(item => {
			if (item.id === elId) {
				item.value = null;
				item.focus = true;
				if (this.fieldFocus) {
					this.renderer.selectRootElement(`#${this.errorFocus}`).focus();
				} else {
					this.renderer.selectRootElement('#scanner_id').focus();
				}
			}
		});
		this.showAlert = false;
	}

	showModalDialog() {
		this.displayModal = true;
		this.beep.errorBeep();
	}

	closeModal() {
		this.displayModal = false;
		this.resetInputFields();
		this.resetModels();
		this.renderer.selectRootElement("#scanner_id").focus();
		this.inputQuantityDisable = true;
	}
}

